import actions from '../../../store/actions';
import ChangeDescription from '../../../infrastructure/types/DifferenceVisualizer/ChangeDescription';
import ChangeLogModal from '../Modals/ChangeLogModal/ChangeLogModal';
import ChangeLogModalState from '../Modals/ChangeLogModal/ChangeLogModalState';
import ColumnDefinition from '../../../infrastructure/types/DataGrid/ColumnDefinition';
import httpClient from '../../../infrastructure/helpers/common/httpClient';
import React from 'react';
import ServerDataGrid from '../DataGrid/ServerDataGrid/ServerDataGrid';
import store from '../../../store/store';
import urlHelper from '../../../infrastructure/helpers/common/urlHelper';
import Version from '../../../types/common/Version';
import versionHelper from '../../../infrastructure/helpers/functions/common/versionHelper';
import ChangeLogNameAndCommentModal from './ChangeLogNameAndCommentModal';
import DownloadModal from '../Modals/DownloadModal/DownloadModal';
import navigationHelper from '../../../infrastructure/helpers/common/navigation/navigation';

interface Props {
    getColumns: (onGetChangesClick: (identifier: string) => Promise<void>,
        onEditClick?: (configVersion: Version) => void,
        onDownloadClick?: (identifier: string) => void,
        showSpinnerForIdentifier?: string,
        hasWriteAccess?: boolean,
        isDisabled?: boolean,
        onRejectClick?: () => void,
        onApproveClick?: () => void,
        version?: string
    ) => ColumnDefinition<Version>[];
    modalColumns: ColumnDefinition<ChangeDescription>[];
    backendRoute: string;
    uniqueName: string;
    reportConfigId?: number;
    nameAndCommentRoute?: string;
    hasWriteAccess: boolean;
    isDisabled?: boolean;
    onRejectClick?: () => void;
    onApproveClick?: () => void;
    version?: string;
}

class ChangeLog extends React.Component<Props, {
    editedConfigVersion: Version;
    showPopupEdit: boolean;
    showDownloadModal: boolean;
    identifier: string;
    showSpinner: boolean;
}> {

    constructor(props: Props) {
        super(props);

        this.state = {
            showPopupEdit: false,
            editedConfigVersion: {} as Version,
            showDownloadModal: false,
            identifier: '',
            showSpinner: false
        }

        this.onGetChangesClick = this.onGetChangesClick.bind(this);
        this.onGetChangesSuccess = this.onGetChangesSuccess.bind(this);
        this.onEditClick = this.onEditClick.bind(this);
        this.onSaveNameAndCommentClick = this.onSaveNameAndCommentClick.bind(this);
        this.onDownloadClick = this.onDownloadClick.bind(this);
        this.onDownloadTypeSelected = this.onDownloadTypeSelected.bind(this);
    }

    onGetChangesClick(identifier: string): Promise<void> {

        let route = urlHelper.buildRoute([this.props.backendRoute, identifier]);

        return httpClient.get<ChangeDescription[]>(route).then(response => this.onGetChangesSuccess(identifier, response.data));
    }

    async onSaveNameAndCommentClick(name: string, comment: string): Promise<void> {

        let version = Object.assign({}, this.state.editedConfigVersion);
        version.name = name;
        version.comment = comment;
        version.reportConfigId = this.props.reportConfigId;

        this.setState({ editedConfigVersion: version, showPopupEdit: false });

        let route = urlHelper.buildRoute([this.props.backendRoute, this.props.nameAndCommentRoute || '']);

        await httpClient.put(route, version);

        navigationHelper.refreshPage();
    }

     onEditClick(reportConfigVersion: Version): void {

        this.setState({ showPopupEdit: true, editedConfigVersion: reportConfigVersion });
    }

    onDownloadClick(identifier: string): void {
        this.setState({ identifier, showDownloadModal: true });
    }

    onGetChangesSuccess(version: string, changes: ChangeDescription[]): void {

        let payload: ChangeLogModalState = {
            isOpen: true,
            title: versionHelper.getDisplayName(version),
            columns: this.props.modalColumns,
            data: changes,
            error: null
        };

        store.dispatch({ type: actions.changeLogModal.open, payload: payload });
    }

    async onDownloadTypeSelected(downloadAsFragmented: boolean): Promise<void> {

        this.setState({ showDownloadModal: false, showSpinner: true });

        let downloadVersionRoute = urlHelper.buildRoute(['report-version', this.props.reportConfigId, downloadAsFragmented ? 'export-fragmented' : 'export-full', 'single', 'download', this.state.identifier]);

        await httpClient.download(downloadVersionRoute, {});

        this.setState({ showSpinner: false });
    }

    render(): JSX.Element {
        return (
            <>
                <ServerDataGrid
                    columns={this.props.getColumns(
                        this.onGetChangesClick,
                        this.onEditClick,
                        this.onDownloadClick,
                        this.state.showSpinner ? this.state.identifier : '',
                        this.props.hasWriteAccess,
                        this.props.isDisabled,
                        this.props.onRejectClick,
                        this.props.onApproveClick,
                        this.props.version)}
                    uniqueName={this.props.uniqueName}
                    dataSourceRoute={this.props.backendRoute}
                    getKey={x => x.identifier}
                    pageSize={10} />

                <ChangeLogModal />
                {
                    this.state.showPopupEdit &&
                    <ChangeLogNameAndCommentModal
                        onSaveClick={this.onSaveNameAndCommentClick}
                        defaultName={this.state.editedConfigVersion.name}
                        defaultComment={this.state.editedConfigVersion.comment}
                    />
                }
                {this.state.showDownloadModal &&
                    <DownloadModal
                        onClose={() => { this.setState({ showDownloadModal: false }) }}
                        onDownload={this.onDownloadTypeSelected}
                        isOpen={this.state.showDownloadModal}
                        showVersionSelection={false} />
                }
            </>
        );
    }
}

export default ChangeLog;
